import { initDataAttributesAction } from "./action/init";

export function initDataAttributes() {

    initDataAttributesAction();

}